import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebhooksComponent } from './webhooks.component';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { TableModule } from 'src/app/common/utilities/table/table.module';
import { ModalModule } from 'src/app/common/components/modal/modal.module';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { SelectModule } from 'src/app/common/utilities/select/select/select.module';
import { DropdownModule } from 'src/app/common/utilities/dropdown/dropdown.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { MultiSelectCheckboxModule } from 'src/app/common/utilities/multi-select-checkbox/multi-select-checkbox.module';
import { CopyTextModule } from 'src/app/common/utilities/copy-text/copy-text.module';
import { ToastModule } from 'primeng/toast';
import { CopyTextSingleLineModule } from 'src/app/common/utilities/copy-text-single-line/copy-text-single-line.module';
import { WebhookTableModule } from 'src/app/common/components/webhook-table/webhook-table.module';



@NgModule({
  declarations: [
    WebhooksComponent
  ],
  imports: [
    CommonModule,
    ButtonFillModule,
    TableModule,
    ModalModule,
    InputModule,
    SelectModule,
    DropdownModule,
    ButtonOutlineModule,
    DashboardModule,
    MultiSelectCheckboxModule,
    CopyTextModule,
    ToastModule,
    CopyTextSingleLineModule,
    WebhookTableModule
  ]
})
export class WebhooksModule { }
